<template>
    <ion-toolbar>
       
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <page-title :title="`Welcome <br/> to ${$filters.appName()}`" subtitle="Pick your role to proceed" showIcon />

            <div class="buttons_wrapper_login">
                <el-button :class="{ active: type === 'locum' || type === 'job-seeker' }" type="primary-light" @click="selectAuthType('locum')">
                    {{ $filters.systemLocumName(true, true) }}
                    <span v-if="type === 'locum' || type === 'job-seeker'" class="checkmark"><svg width="20" height="20" viewBox="0 0 20 20"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z"
                                fill="white" />
                        </svg>
                    </span>
                </el-button>
                <el-button :class="{ active: type === 'pharmacy'}" type="primary-light"
                    @click="selectAuthType('pharmacy')">
                    {{messages.employer}}
                    <span v-if="type === 'pharmacy'" class="checkmark"><svg width="20" height="20" viewBox="0 0 20 20"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z"
                                fill="white" />
                        </svg>
                    </span>
                </el-button>
                <el-button :class="{ active: type === 'group-manager'}" type="primary-light"
                    @click="selectAuthType('group-manager')">
                    Group Owner / Manager
                    <span v-if="type === 'group-manager'" class="checkmark"><svg width="20" height="20" viewBox="0 0 20 20"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z"
                                fill="white" />
                        </svg>
                    </span>
                </el-button>
              
            </div>
        </div>

        <div class="background-circles">
            <div class="circle circle-2"></div>
            <div class="circle circle-1"></div>
            <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/PageTitle/PageTitle.vue';
import {
    inject,
    onMounted,
    onUnmounted,
    ref,
} from 'vue';
import store from "@/store/store";
import {
    IonToolbar,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    useRouter,
} from 'vue-router'
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
    components: {
        IonToolbar,
        PageTitle,
        SvgIcon
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const userType = store.getters.GET_USER_ROLE;
        const type = ref(userType ? userType : '');
        const messages = inject('messages');
        const groupManagerLoginUrl = process.env.VUE_APP_GROUP_MANAGER_LOGIN_URL;
        console.log("🚀 ~ setup ~ groupManagerLoginUrl:", groupManagerLoginUrl)
        const selectAuthType = (selectedType) => {
            type.value = selectedType;
            goNext();
        }

        const goBack = () => {
            $router.push({
                name: 'auth',
            })
        }

        const goNext = () => {
            $store.dispatch('SET_USER_ROLE', type.value);

            if (type.value === 'locum' || type.value === 'job-seeker'|| type.value === 'pharmacy') {
                $router.push({
                    name: 'auth',
                })
            } else {             
                window.location.href = groupManagerLoginUrl;
            }

        };

        onMounted(() => {
            $('body').addClass('background_blue');
        });

        onUnmounted(() => {
            $('body').removeClass('background_blue');
        });
        return {
            selectAuthType,
            goBack,
            goNext,
            type,
            messages,
            groupManagerLoginUrl
        }
    }
}
</script>
